import type { AccountWithMetrics } from "../../../api/src/accounts/accounts.service";
import type { HouseholdWithAccounts } from "../../../api/src/households/households.service";

/**
 * Determines if there are accounts without models that need model assignments.
 * Only considers accounts with AUM > $0 for model validation.
 *
 * @param household - The household data with accounts
 * @param accountsWithBalances - Accounts with their balance metrics
 * @returns true if there are active accounts (AUM > $0) without models when no household model exists
 */
export function hasAccountsWithoutModels(
  household: HouseholdWithAccounts | undefined,
  accountsWithBalances: Pick<
    AccountWithMetrics,
    "accountBalance" | "assignedModelId"
  >[],
): boolean {
  if (!household?.accounts) return false;

  // If household has a model assigned, all accounts inherit it
  if (household.assignedModelId != null) return false;

  // Filter to only accounts with AUM > 0
  const activeAccounts = accountsWithBalances.filter(
    (account) => (account.accountBalance ?? 0) > 0,
  );

  // Check if any active accounts lack model assignments
  return activeAccounts.some(
    (account) =>
      account.assignedModelId === null || account.assignedModelId === undefined,
  );
}
